import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HolisMassage } from './pages/HolisMassage';
import { AdminPanel } from './pages/AdminPanel';
import { PrivacyPolicy } from './pages/PrivacyPolicy';
import { CookieConsent } from './components/CookieConsent';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HolisMassage />} />
        <Route path="/admin" element={<AdminPanel />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      </Routes>
      <CookieConsent />
    </Router>
  );
}

export default App;
